export default "__VITE_ASSET__Z$93fgO9__"